var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenInNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.2482C1.45 20.2482 0.979167 20.0377 0.5875 19.6167C0.195833 19.1956 0 18.6895 0 18.0983V3.04841C0 2.45717 0.195833 1.95103 0.5875 1.52999C0.979167 1.10896 1.45 0.898438 2 0.898438H9V3.04841H2V18.0983H16V10.5733H18V18.0983C18 18.6895 17.8042 19.1956 17.4125 19.6167C17.0208 20.0377 16.55 20.2482 16 20.2482H2ZM6.7 14.5508L5.3 13.0458L14.6 3.04841H11V0.898438H18V8.42336H16V4.5534L6.7 14.5508Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInNew);
export default __webpack_public_path__ + "static/media/openInNew.20317ed3f832e3c685fa1a3aa83b1278.svg";
export { ForwardRef as ReactComponent };